<template>
  <div class="youtube-list page-container">
    <header class="youtube-list__header">
      <div class="youtube-list__title-wrap">
        <h3 class="youtube-list__title">{{ title }}</h3>
        <a v-if="link" :href="link" class="youtube-list__more">
          {{ computedLinkTitle }}
        </a>
      </div>
    </header>
    <ul class="youtube-list__list">
      <li class="youtube-list__item" v-for="(item, i) in videos" :key="i">
        <YoutubeItem
          :link="item.url"
          :video-id="item.video_id"
          :title="item.title"
          :image="item.image_src"
          :date="item.published_at"
          :block-name="titleRu"
          :position="i + 1"
          is-slider
        />
      </li>
    </ul>
  </div>
</template>

<script>
import YoutubeItem from './YoutubeItem'

export default {
  name: 'YoutubeList',
  components: {
    YoutubeItem
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    titleRu: {
      type: String,
      default: ''
    },
    link: {
      type: String,
      default: ''
    },
    linkTitle: {
      type: String,
      default: ''
    },
    videos: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    computedLinkTitle () {
      return this.linkTitle || this.$t('see_all')
    }
  }
}
</script>

<style scoped lang="sass">

.youtube-list__header
  display: flex
  flex-flow: row nowrap
  justify-content: space-between
  align-items: center
  margin-bottom: 15px

  +mmin($tablet)
    margin-bottom: 30px

.youtube-list__title-wrap
  display: flex
  flex-flow: row wrap
  align-items: baseline
  justify-content: space-between
  width: 100%

  +mmin($tablet)
    width: auto
    justify-content: flex-start

.youtube-list__title
  font-size: 18px
  font-weight: 500
  padding: 0
  margin: 0

  +mmin($tablet)
    font-size: 24px

.youtube-list__more
  color: $main-color
  font-size: 14px
  font-weight: 400 //Rubik 300

  +mmin($tablet)
    font-size: 16px
    margin-left: 20px

  &:hover,
  &:focus,
  &:active
    color: $main-color--hover

// youtube list
.youtube-list__list
  +list-unstyled
  display: flex
  flex-flow: row wrap

.youtube-list__item
  width: 100%
  margin: 0 0 30px

  &:last-child
    margin-bottom: 0

  +mmin($tablet)
    width: calc(50% - 12.5px)

    &:not(:nth-child(2n))
      margin-right: 25px

    &:nth-last-child(-n + 2)
      margin-bottom: 0

  +mmin($tablet--hor)
    width: calc(33.333% - 16.666px)

    &:not(:nth-child(2n))
      margin-right: 0

    &:not(:nth-child(3n))
      margin-right: 25px

    &:nth-last-child(-n + 3)
      margin-bottom: 0

</style>
